import { Pipe, PipeTransform } from '@angular/core';
import { parseTz } from './time';

// Affichage d'un INSTANT (timestamptz du back) en heure murale MÉTIER — voir shared/time.ts.
// Remplace le DatePipe d'Angular pour ces champs : lui rend l'heure du NAVIGATEUR (son paramètre
// timezone n'accepte que des offsets fixes, inutilisables avec l'heure d'été), un poste réglé sur
// un autre fuseau affichait donc d'autres heures que le magasin.
// Les formats sont ceux de dayjs : 'DD/MM/YYYY HH:mm' (et non 'dd/MM/yyyy HH:mm').
// Pour une DATE nue ('YYYY-MM-DD', ex. askdatdel), le DatePipe d'Angular reste très bien : pas
// d'instant, pas de fuseau, rien à convertir.
@Pipe({ name: 'tzdate', standalone: true })
export class TzDatePipe implements PipeTransform {
	transform(v: string | Date | null | undefined, format = 'DD/MM/YYYY HH:mm'): string {
		return parseTz(v)?.format(format) ?? '';
	}
}
